import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getApi, postApi } from "../../Helpers/Axios";
import { useSelector } from "react-redux";

const AddSubAdmin = () => {
  const navigate = useNavigate();
  const admin = useSelector((state) => state?.auth?.user);
  let [searchParams, setSearchParams] = useSearchParams();
  const [villageData, setvillageData] = useState(null);
  const isEdit = searchParams.get("edit_id");
  useEffect(() => {
    if (searchParams.get("edit_id")) {
      handleEdit();
    }
    fetchVillage();
  }, [searchParams.get("edit_id")]);

  const fetchVillage = async () => {
    let url = `villages`;
    await getApi(url, true).then((response) => {
      if (response.status === 200) {
        setvillageData(response.data);
      }
    });
  };

  const handleEdit = async () => {
    let url = `get-sub-admin?edit_id=${searchParams.get("edit_id")}`;
    await getApi(url, true).then((response) => {
      if (response.status === 200) {
        setInitialValueData(response.data);
      }
    });
  };

  const [initialValues, setInitialValueData] = useState({
    fullname: null,
    village_id: null,
    email: null,
    password: null,
    is_admin: 1,
    status: 1,
  });

  const validationSchema = Yup.object({
    fullname: Yup.string().required("Name is required."),
    village_id: Yup.string().required("Village name is required."),
    email: Yup.string()
      .required("Email is required.")
      .matches("^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$", "Invalid email address."),
    password: isEdit
      ? Yup.string() // Optional validation for edit
      : Yup.string()
          .max(16, "Must be 16 characters or less.")
          .min(6, "Must be 6 characters or greater.")
          .required("Password is required."),
  });

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      values.status = values.status ? 1 : 0;
      let url = searchParams.get("edit_id")
        ? `add-edit-sub-admin?edit_id=${searchParams.get("edit_id")}`
        : "add-edit-sub-admin";
      await postApi(url, values, true)
        .then((response) => {
          if (response.status === 200) {
            navigate("/sub-admin");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  return (
    <div>
      <div>
        <div>
          <p className="breadcrumbs">
            <Link to="/dashboard">
              <span>Dashboard</span>
            </Link>{" "}
            /{" "}
            <Link to="/sub-admin">
              <span>Sub Admin</span>
            </Link>{" "}
            / <span>Add</span>
          </p>
        </div>
      </div>
      <div>
        <form method="post" className="add-detail-main" onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row">
            <div className="col-md-6">
              <div class="form-with-lable">
                <label class="mt-1 form_label">Full Name</label>
                <div class="input-box">
                  <input
                    type="text"
                    placeholder="Enter fullname"
                    name="fullname"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.fullname}
                  />
                </div>
              </div>
              {errors?.fullname && touched?.fullname ? <span className="require-text">{errors?.fullname}</span> : null}
            </div>
            <div className="col-md-6">
              <div className="form-with-lable">
                <label className="form_label">Village</label>
                <select
                  className="form-select"
                  multiple
                  value={values?.village_id ? values.village_id.split(",") : []} // split comma string into array
                  onChange={(e) => {
                    const selectedOptions = Array.from(e.target.selectedOptions).map((option) => option.value);
                    setFieldValue("village_id", selectedOptions.join(",")); // store as comma-separated string
                  }}
                >
                  {villageData?.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name_eng} ({item.name_gj})
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div class="form-with-lable mt-3">
                <label class="form_label">Email</label>
                <div class="input-box">
                  <input
                    type="text"
                    placeholder="Enter email"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.email}
                  />
                </div>
              </div>
              {errors?.email && touched?.email ? <span className="require-text">{errors?.email}</span> : null}
            </div>
            <div className="col-md-6">
              <div class="form-with-lable mt-3">
                <label class="form_label">Password</label>
                <div class="input-box">
                  <input
                    type="password"
                    placeholder="Enter password"
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.password}
                  />
                </div>
              </div>
              {errors?.password && touched?.password ? <span className="require-text">{errors?.password}</span> : null}
            </div>
          </div>
          <Form.Check
            type="switch"
            id="custom-switch"
            label="Status"
            className="float-end mt-2"
            checked={values?.status}
            onChange={(e) => setFieldValue("status", !values?.status)}
          />
          <div className="text-center mt-4">
            <button type="submit" className="theme-btn px-4">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSubAdmin;
